import { FilterKey } from 'interfaces/cohort';
import { useMemo } from 'react';
import { BooleanParam, JsonParam, NumberParam, StringParam, useQueryParams } from 'use-query-params';
import { getFeatureObjectFromFeatureFiltersQueryParams, getFiltersFromQueryObject } from 'utils/advancedFilterAdapter';
import { resultsModeQueryParam } from 'utils/useEncodedFilters/constants';
import useFilterFieldsConfig from '../ProcedureFilterFields';

export const paramsConfig = {
  advancedSearchDrawerOpen: BooleanParam,
  saveCohortModalOpen: BooleanParam,
  queryId: StringParam,
  cohortId: StringParam,
  filters: JsonParam,
  features: JsonParam,
  clinicalData: JsonParam,
  labId: StringParam,
  resultsMode: resultsModeQueryParam,
  page: NumberParam,
  slidesMode: BooleanParam,
  searchTerm: StringParam,
};

const useSearchFiltersFromQueryParams = (includeMainFilters: boolean = true) => {
  const [queryParams, setQueryParams] = useQueryParams(paramsConfig);
  const filterFieldsConfig = useFilterFieldsConfig();

  const initialQueryObjectForFilters = useMemo(
    () => ({
      queryId: queryParams.queryId,
      ...queryParams.filters,
      ...queryParams.features,
      ...queryParams.clinicalData,
    }),
    [queryParams]
  );

  const searchFiltersFromQueryParams: Record<FilterKey, any> = useMemo(() => {
    return getFiltersFromQueryObject(initialQueryObjectForFilters, filterFieldsConfig, includeMainFilters);
  }, [initialQueryObjectForFilters, includeMainFilters]);

  const featuresFromQueryParams = getFeatureObjectFromFeatureFiltersQueryParams(
    queryParams?.features,
    queryParams?.filters?.orchestrationId
  );

  return {
    searchFiltersFromQueryParams,
    setQueryParams,
    queryParams,
    featuresFromQueryParams,
  };
};

export default useSearchFiltersFromQueryParams;
